// Copy + starter suggestions for the BEXI Studio agent empty state.

export const BEXI_INTRO = "I'm BEXI, your Studio agent. I build Digital Employees, apps and collections in this organization. What should we build?";

// Models the picker offers (per-run). Reached through Novita on the server.
export const MODELS = [
    {
        value: 'glm',
        label: 'GLM-4.5 Air'
    },
    {
        value: 'qwen',
        label: 'Qwen3.8 27B'
    },
    {
        value: 'kimi',
        label: 'Kimi K2'
    },
];

export const STARTERS = [
    'Build a Digital Employee that answers HR leave questions',
    'What can I build here?',
    'Create an app with a journey to onboard a customer',
    'Draft an opcode that calls an API and summarizes the result',
    'Show me my sub-organizations',
    'Add a knowledge collection and ingest a document',
    'List the app kinds and what each is for',
    'Make a collection that groups this app’s journeys',
];

// Friendly labels for the single status line while a tool runs.
export const TOOL_LABELS = {
    pilotage_manifest: 'Reading the contract',
    pilotage_get_guide: 'Reading the guide',
    pilotage_catalog: 'Looking up ids',
    bexi_get_planning_guide: 'Reading planning guide',
    bexi_set_checklist: 'Creating checklist',
    bexi_update_checklist_step: 'Updating checklist',
    bexi_finish: 'Finishing task',
    bexi_ask_user: 'Asking a question',
    bexi_setup_access: 'Setting up login & access',
    bexi_scaffold_screen: 'Building a screen',
    build_bootstrap: 'Creating the app',
    build_access: 'Setting up login & roles',
    build_model: 'Creating a data model',
    build_workflows: 'Building workflows',
    build_screen: 'Building a screen',
    de_capabilities: 'Checking DE capabilities',
    app_capabilities: 'Checking app capabilities',
    de_validate: 'Validating the DE',
    app_validate: 'Validating the app',
    list_models: 'Listing models',
    list_roles: 'Listing roles',
    list_sub_organizations: 'Listing sub-organizations',
    app_run_status: 'Checking run status',
    ingestion_status: 'Checking ingestion',
    current_page: 'Checking the page',
    web_search: 'Searching the web',
    set_vault_secret: 'Storing a secret in Vault',
};

export const toolLabel = (name) => TOOL_LABELS[name] || `Running ${name}`;

/** Pick `n` random starters (Fisher-Yates, browser Math.random is fine here). */
export function shuffledStarters(n = 4) {
    const a = [...STARTERS];
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a.slice(0, n);
}
